export const GET_SCHEDULE_REQUEST = 'GET_SCHEDULE_REQUEST';
export const GET_SCHEDULE_SUCCESS = 'GET_SCHEDULE_SUCCESS';
export const GET_SCHEDULE_ERROR = 'GET_SCHEDULE_ERROR';

export const SUBMIT_CUSTOM_SHIFT_SCHEDULE_REQUEST =
  'SUBMIT_CUSTOM_SHIFT_SCHEDULE_REQUEST';
export const SUBMIT_CUSTOM_SHIFT_SCHEDULE_SUCCESS =
  'SUBMIT_CUSTOM_SHIFT_SCHEDULE_SUCCESS';
export const SUBMIT_CUSTOM_SHIFT_SCHEDULE_ERROR =
  'SUBMIT_CUSTOM_SHIFT_SCHEDULE_ERROR';

export const CREATE_OR_UPDATE_DOWNTIMES_REQUEST =
  'CREATE_OR_UPDATE_DOWNTIMES_REQUEST';
export const CREATE_OR_UPDATE_DOWNTIMES_SUCCESS =
  'CREATE_OR_UPDATE_DOWNTIMES_SUCCESS';
export const CREATE_OR_UPDATE_DOWNTIMES_ERROR =
  'CREATE_OR_UPDATE_DOWNTIMES_ERROR';

export const GET_COMPANY_SCHEDULE_REQUEST = 'GET_COMPANY_SCHEDULE_REQUEST';
export const GET_COMPANY_SCHEDULE_SUCCESS = 'GET_COMPANY_SCHEDULE_SUCCESS';
export const GET_COMPANY_SCHEDULE_ERROR = 'GET_COMPANY_SCHEDULE_ERROR';

export const SAVE_COMPANY_SCHEDULE_REQUEST = 'SAVE_COMPANY_SCHEDULE_REQUEST';
export const SAVE_COMPANY_SCHEDULE_SUCCESS = 'SAVE_COMPANY_SCHEDULE_SUCCESS';
export const SAVE_COMPANY_SCHEDULE_ERROR = 'SAVE_COMPANY_SCHEDULE_ERROR';

export const LIST_SHIFT_INDIVIDUAL_EDITIONS_REQUEST =
  'LIST_SHIFT_INDIVIDUAL_EDITIONS_REQUEST';
export const LIST_SHIFT_INDIVIDUAL_EDITIONS_SUCCESS =
  'LIST_SHIFT_INDIVIDUAL_EDITIONS_SUCCESS';
export const LIST_SHIFT_INDIVIDUAL_EDITIONS_ERROR =
  'LIST_SHIFT_INDIVIDUAL_EDITIONS_ERROR';
